(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        $(function () {
            var $body = $('body');
            var leaveShown = window.utils.cookies.get('leave_shown_v2') || false;
            var $content = $('#leave-subscribe-modal-content');

            function showLeaveFrom() {
                if (parseInt(leaveShown) !== 1) {
                    bs3popup({
                        content: $content.html(),
                        width: 550,
                        getLock: true,
                        setLock: true,
                        onAfterShow: function onAfterShow() {
                            // только при действительном показе модалки установить куку и отписаться от события
                            var keepForDays = 1;
                            window.utils.cookies.set('leave_shown_v2', 1, { expires: keepForDays * 24 * 60 * 60, path: '/' });
                            $body.off('mouseleave');
                        }
                    });
                }
            }

            $body.on('mouseleave', function (e) {
                if (e.clientY < 10) {
                    showLeaveFrom();
                }
            });
        });
    }, {}] }, {}, [1]);